import { cardMargin, cardSize, cardSizeMobileM } from "./constants";

export const calculateGridWidth = () => {
  const screenWidth = window.innerWidth;
  const cardSlotSize = screenWidth > 600 ? cardSize + cardMargin * 2 : cardSizeMobileM + cardMargin * 2;
  const slotsNum = Math.floor(screenWidth / cardSlotSize);

  return slotsNum * cardSlotSize;
};
